export const REG_NOT_NUMBERS = new RegExp('\\D', 'g')
export const REG_NOT_LOW_LETTERS_NUMBERS = new RegExp(/[^a-z0-9]/g)
export const REG_ANY_LETTER = new RegExp(/^\p{L}+$/u)
